// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__25fpM"};